import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputRadioGroupComponent } from './input-radio-group.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorsLabelModule } from '../errors-label/errors-label.module';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  declarations: [InputRadioGroupComponent],
  imports: [
    CommonModule,
    ErrorsLabelModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  exports: [InputRadioGroupComponent],
})
export class InputRadioGroupModule {}
